import { useState } from 'react';
import { useParams } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { getJson, postJson } from '../api/client.ts';
import { PublicShell } from '../components/layout.tsx';
import { Button, ErrorNote, Notice, Spinner } from '../components/ui.tsx';

/** Einrichtung eines Hallen-Tablets über den Einmal-Link (F45). Erst der Knopf setzt das Geräte-Cookie. */
export function TabletSetupPage() {
  const { token } = useParams({ from: '/tablet/$token' });
  const info = useQuery({
    queryKey: ['tablet', token],
    queryFn: () => getJson<{ label: string }>(`/api/devices/${token}`),
    retry: false,
    // Nach dem Knopf ist der Einmal-Link verbraucht: Ein neuer Abruf könnte nur noch 410 liefern.
    // Beim Zurückkehren kommt deshalb nur ein gescheiterter erster Abruf noch einmal.
    refetchOnWindowFocus: (query) => query.state.data === undefined,
  });
  const [done, setDone] = useState(false);
  const [error, setError] = useState<unknown>(null);
  return (
    <PublicShell>
      <div className="ad-card space-y-4">
        <h1 className="text-xl">Hallen-Tablet einrichten</h1>
        {info.isPending ? (
          <Spinner />
        ) : info.isLoadingError ? (
          <ErrorNote error={info.error} />
        ) : done ? (
          <>
            <Notice tone="ok">Dieses Gerät ist jetzt als „{info.data.label}“ registriert. Anmeldungen laufen hier mit kurzer Sitzung und großem Abmeldeknopf.</Notice>
            <a className="ad-big-button" href="/">
              Zur Anmeldung
            </a>
          </>
        ) : (
          <>
            <p>
              Dieses Gerät als <strong>{info.data.label}</strong> registrieren?
            </p>
            {error ? <ErrorNote error={error} /> : null}
            <Button
              size="lg"
              onClick={async () => {
                try {
                  await postJson(`/api/devices/${token}/claim`);
                  setDone(true);
                } catch (err) {
                  setError(err);
                }
              }}
            >
              Gerät benennen
            </Button>
          </>
        )}
      </div>
    </PublicShell>
  );
}
